import { useMutation } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { AuthResponseSchema, LoginInputSchema } from './auth.contract'
import type { AuthResponse, LoginInput } from './auth.contract'

async function login(input: LoginInput): Promise<AuthResponse> {
  const payload = LoginInputSchema.parse(input)
  const data = await apiFetch<unknown>('/admin/auth/login', {
    method: 'POST',
    body: {
      email: payload.email,
      password: payload.password,
    },
    recaptchaToken: payload.recaptchaToken,
  })
  return AuthResponseSchema.parse(data)
}

export function useLoginMutation() {
  return useMutation({ mutationFn: login })
}
